"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllReportsSchema = exports.CollectionObjectSchema = exports.ReportObjectSchema = exports.reportManagerRoles = void 0;
const joi_1 = __importDefault(require("joi"));
const dbschema_1 = require("@karya/dbschema");
/**
 * Project roles that fully manage reports (create / update / delete) and can
 * view every report within their project. Because they implicitly see all
 * reports, they are excluded from a report's `allowed_roles` selection.
 */
exports.reportManagerRoles = Object.freeze(['PROJECT_MANAGER', 'TECH_SUPPORT']);
exports.ReportObjectSchema = joi_1.default.object({
    name: joi_1.default.string().required(),
    type: joi_1.default.string()
        .valid(...dbschema_1.ReportTypes)
        .required(),
    query: joi_1.default.string().required(),
    params: joi_1.default.array().items(joi_1.default.object({
        name: joi_1.default.string().required(),
        type: joi_1.default.string().required(),
        value: joi_1.default.any(),
        comments: joi_1.default.string(),
    })),
    public: joi_1.default.boolean(),
    allowedFor: joi_1.default.array().items(joi_1.default.string().valid(...dbschema_1.projectRoles)),
    projectIds: joi_1.default.array().items(joi_1.default.string()),
});
exports.CollectionObjectSchema = joi_1.default.object({
    name: joi_1.default.string().required(),
    type: joi_1.default.string().valid('collection').required(),
    items: joi_1.default.array().items(joi_1.default.object({
        id: joi_1.default.string().required(),
        name: joi_1.default.string().required(),
        query: joi_1.default.string().required(),
        type: joi_1.default.string().valid('bar', 'filtered-bar', 'filtered-grouped-bar').required(),
    })),
    // Optional query to get the downloadable summary for the collection
    query: joi_1.default.string(),
    public: joi_1.default.boolean(),
    allowedFor: joi_1.default.array().items(joi_1.default.string().valid(...dbschema_1.projectRoles)),
    projectIds: joi_1.default.array().items(joi_1.default.string()),
});
exports.AllReportsSchema = joi_1.default.object({
    platform: joi_1.default.object().pattern(joi_1.default.string(), exports.ReportObjectSchema),
    project: joi_1.default.object().pattern(joi_1.default.string(), exports.ReportObjectSchema),
    task: joi_1.default.object().pattern(joi_1.default.string(), exports.ReportObjectSchema),
    worker: joi_1.default.object().pattern(joi_1.default.string(), exports.ReportObjectSchema),
    miscellaneous: joi_1.default.object().pattern(joi_1.default.string(), exports.ReportObjectSchema),
    graphs: joi_1.default.object().pattern(joi_1.default.string(), exports.CollectionObjectSchema),
});
//# sourceMappingURL=Index.js.map